module.exports = __webpack_public_path__ + "img/de-product-classify_img_4.3f64de7c.jpg";